module.exports = new __parcel__URL__("cloud-graphic.d2d73239.svg").toString();